'use strict';
angular.module('impactx.percentage', [])
    .filter('percentage', ['$window', function ($window) {
        return function (input, decimals, suffix) {
            decimals = angular.isNumber(decimals)? decimals :  2;
            suffix = suffix || '%';
            if ($window.isNaN(input)) {
                return '';
            }
            return Math.round(input * Math.pow(10, decimals + 2))/Math.pow(10, decimals) + suffix
        };
    }])
    .directive('appPercentInput', ['$locale', function($locale) {
    return {
        restrict: 'A',
        scope: {
            percentPow: "@",
            nullIfEmpty: "=",
            allowBiggerHundred: "=",
            fractionSize: "=",
            shorten100Percent: "=",
            allow100Percent: "=?"
        },
        require: 'ngModel',
        link: function(scope, element, attrs, ngModelController) {
            var regExp = /[^0-9.,]+/;
            if (!scope.percentPow) {
                scope.percentPow = 0;
            }
            var regExpPercent =  /[^0-9.,%]+/;
            if(isUndefined(scope.allow100Percent))
            {
                scope.allow100Percent=true;
            }
            ngModelController.$parsers.push(function(data) {
                var formats = $locale.NUMBER_FORMATS;
                var validInput;
                if (scope.fractionSize !== undefined) {
                    validInput = data.toString().replace(regExp, "");
                    var index = validInput.lastIndexOf(formats.DECIMAL_SEP)
                    if(index > 0)
                    {
                        validInput = validInput.substring(0, index + scope.fractionSize + 1) ;
                    }
                    validInput += "%";
                }
                else {
                    validInput = data.toString().replace(regExpPercent, "");
                    var indexOfPercent = validInput.indexOf("%");
                    while (indexOfPercent < validInput.length - 1 && indexOfPercent > -1)
                    {
                        validInput = validInput.replace("%", "");
                    }
                }

                while(validInput.split(formats.DECIMAL_SEP).length - 1 > 1) {
                    //more than one decimal separator is bad...
                    validInput = validInput.replace(formats.DECIMAL_SEP, "");
                }

                if (data != validInput) {
                    ngModelController.$setViewValue(validInput);
                    ngModelController.$rollbackViewValue();
                    return ngModelController.$modelValue;
                }
                var correctedValue = data.toString().replace(regExp, "");
                correctedValue = correctedValue.replace(formats.GROUP_SEP, "");
                correctedValue = correctedValue.replace(formats.DECIMAL_SEP, ".");
                if (correctedValue > 100 && !scope.allowBiggerHundred)
                {
                    correctedValue = 100;
                    ngModelController.$setViewValue(correctedValue + "%");
                    ngModelController.$rollbackViewValue();
                    return ngModelController.$modelValue;
                }
                if(!scope.allow100Percent)
                {
                    ngModelController.$setValidity("is100", correctedValue != 100)
                }
                //elm.val(correctedValue);
                if(correctedValue === "" && scope.nullIfEmpty){
                    return null;
                }
                if (scope.percentPow > 0) {
                    return correctedValue / Math.pow(10, Number(scope.percentPow));
                }
                return correctedValue
            });

            ngModelController.$formatters.push(function(data) {
                if (data)
                {
                    var formats = $locale.NUMBER_FORMATS;
                    var fractionSize = scope.fractionSize || formats.PATTERNS[1].maxFrac;
                    var pattern =
                    {
                        "gSize": 3,
                        "lgSize": 3,
                        "maxFrac": fractionSize,
                        "minFrac": 0,
                        "negPre": "-",
                        "negSuf": "",
                        "posPre": "",
                        "posSuf": "%"
                    };
                    var formattedNumber = formatNumber( Math.round(data * Math.pow(10, fractionSize + Number(scope.percentPow)))/
                        Math.pow(10, fractionSize), pattern, formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize);
                    if (scope.shorten100Percent) {
                        var check100 = "100";
                        if (fractionSize && fractionSize > 0) {
                            check100 += formats.DECIMAL_SEP;
                            for (var i = 0; i < fractionSize; i++) {
                                check100 += "0";
                            }
                        }
                        check100 += "%";
                        if (formattedNumber === check100) {
                            formattedNumber = "100%"
                        }
                    }
                    if(!scope.allow100Percent)
                    {
                        ngModelController.$setValidity("is100", data != 100)
                    }

                    return formattedNumber;
                }
                else
                {
                    if(data === 0 || !scope.nullIfEmpty){
                        return 0 + "%";
                    }
                    return null;
                }
            });
        }
    }
}]);